export interface Activo {
  usuarioCreadorSolicitud: any;
  modelo: string;
  folio: string;
  Usuario: string;
  id: number;
  nombre: string;
  numeroSerie: string;
  tipo: string;
  estado: string;
  ubicacion: string;
  URL_Imagen?: string;
  solicitudId?: number;
  motivoGeneral?: string;
}

export interface Hotel { id: string; nombre: string; }

export interface MotivoActivo { activoId: number; motivo: string; }

export interface FirmaST {
  uid: number;
  orden: number;
  nombre: string;
  puesto: string;
  firma: string;
  firmo: boolean;
}

export interface Firma {
  [x: string]: any;
  usuario_id: any;
  FullName: string;
  orden: any;
  firmo: number;
  firma_base?: string;
  nombre: string;
  puesto: string;
  firma: string;
  canvasRef?: any;
  Id?: number;
}

export type VistaActual = 'lista' | 'baja' | 'salida' | 'salida-temporal';

export const hotelMap: Record<string, number> = {
  GVRN: 1, GVRM: 2, GVBLC: 3, GVLC: 4, VV: 5, CV: 6, MDC: 7, CC: 8, DEMO: 9,
};

export const getDefaultImage = (tipo: string) => {
  switch (tipo.toLowerCase()) {
    case 'laptop':    return 'https://via.placeholder.com/40x40/3B82F6/FFFFFF?text=💻';
    case 'proyector': return 'https://via.placeholder.com/40x40/10B981/FFFFFF?text=📽';
    case 'impresora': return 'https://via.placeholder.com/40x40/EF4444/FFFFFF?text=🖨';
    case 'tablet':    return 'https://via.placeholder.com/40x40/8B5CF6/FFFFFF?text=📱';
    case 'teléfono':  return 'https://via.placeholder.com/40x40/F97316/FFFFFF?text=📞';
    case 'servidor':  return 'https://via.placeholder.com/40x40/6B7280/FFFFFF?text=🖥';
    default:          return 'https://via.placeholder.com/40x40/9CA3AF/FFFFFF?text=📦';
  }
};

export const getEstadoColor = (estado: string) => {
  switch (estado) {
    case 'ACTIVO':    return 'green';
    case 'ASIGNADO':  return 'blue';
    case 'PENDIENTE': return 'yellow';
    case 'PTE. BAJA': return 'orange';
    case 'BODEGA':    return 'cyan';
    case 'INACTIVO':  return 'red';
    case 'BAJA':      return 'red';
    case 'RMA':       return 'cyan';
    default:          return 'gray';
  }
};
